var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_525_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 9,
    width: 12,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.87207H11.8799V15.4026H0V9.87207Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_525_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94067 10.9971C2.74492 10.9971 1.12492 11.5461 1.12492 12.6298C1.12492 13.7233 2.74492 14.2776 5.94067 14.2776C9.13567 14.2776 10.7549 13.7286 10.7549 12.6448C10.7549 11.5513 9.13567 10.9971 5.94067 10.9971ZM5.94067 15.4026C4.47142 15.4026 -7.62939e-05 15.4026 -7.62939e-05 12.6298C-7.62939e-05 10.1578 3.39067 9.87207 5.94067 9.87207C7.40992 9.87207 11.8799 9.87207 11.8799 12.6448C11.8799 15.1168 8.48992 15.4026 5.94067 15.4026Z",
    fill: "#7B6F72"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_525_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 9,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9574 0.5H9.92242V8.46395H1.9574V0.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_525_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94068 1.57051C4.33493 1.57051 3.02843 2.87626 3.02843 4.48201C3.02318 6.08251 4.31993 7.38751 5.91893 7.39351L5.94068 7.92901V7.39351C7.54568 7.39351 8.85143 6.08701 8.85143 4.48201C8.85143 2.87626 7.54568 1.57051 5.94068 1.57051ZM5.94067 8.46376H5.91667C3.72517 8.45701 1.94992 6.66976 1.95742 4.47976C1.95742 2.28601 3.74392 0.499512 5.94067 0.499512C8.13667 0.499512 9.92242 2.28601 9.92242 4.48201C9.92242 6.67801 8.13667 8.46376 5.94067 8.46376Z",
    fill: "#7B6F72"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8fe4d2fa4ef8c283b9ca32453e0710ec.svg";
export { ForwardRef as ReactComponent };